(function () {
  'use strict';
  function tokens(value) {
    return (Array.isArray(value) ? value : String(value || '').split(',')).map(function (v) { return v.trim().toLowerCase().replace(/[ _]+/g, '-'); });
  }
  function matches(product, fields) {
    var tags = tokens(product.tags).concat(tokens(product.family));
    var scents = { fresh: ['fresh', 'family-fresh'], sweet: ['sweet', 'gourmand', 'family-sweet'], oud: ['oud', 'family-oud'], woody: ['woody', 'family-woody'], spicy: ['spicy', 'family-spicy'], floral: ['floral', 'family-floral', 'rose'] };
    var occasions = { daily: ['daily', 'day'], office: ['office'], date: ['date', 'date-night'], formal: ['formal', 'events', 'wedding', 'weddings'] };
    var wear = tokens(product.tags).concat(tokens(product.occasions));
    var strengths = { moderate: ['moderate'], strong: ['strong'], very_strong: ['very-strong', 'beast-mode'] };
    var strength = tokens(product.strength || product.sillage)[0];
    if (!scents[fields.scent].some(function (v) { return tags.indexOf(v) !== -1; }) || !occasions[fields.occasion].some(function (v) { return wear.indexOf(v) !== -1; }) || strengths[fields.performance].indexOf(strength) === -1) return null;
    var bands = { under10: [0, 1000000], '10to15': [1000000, 1500000], '15to20': [1500000, 2000000], over20: [2000000, Infinity] };
    var band = bands[fields.budget];
    return product.variants.filter(function (v) { return v.available && v.cents >= band[0] && v.cents < band[1]; }).sort(function (a, b) { return a.cents - b.cents; })[0] || null;
  }
  function init() {
    document.querySelectorAll('[data-zk-discovery]').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = 'true';
      var form = root.querySelector('form');
      var result = root.querySelector('[data-zk-discovery-result]');
      var source = root.querySelector('[data-zk-discovery-data]');
      var products = [];
      try { if (source) products = JSON.parse(source.textContent); } catch (error) { products = []; }
      var status = root.querySelector('[data-zk-discovery-status]');
      form.addEventListener('change', function () { result.hidden = true; });
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!form.reportValidity()) return;
        var fields = {};
        ['scent', 'occasion', 'performance', 'budget'].forEach(function (key) { fields[key] = form.elements[key].value; });
        var count = 0;
        var currencyOK = !root.dataset.currency || root.dataset.currency === 'PKR';
        root.querySelectorAll('[data-zk-discovery-rule]').forEach(function (rule) {
          var match = currencyOK && Object.keys(fields).every(function (key) { return rule.dataset[key] === fields[key]; });
          rule.hidden = !match;
          if (match) count++;
        });
        var grid = root.querySelector('[data-zk-discovery-products]');
        if (grid) grid.replaceChildren();
        if (currencyOK && grid) products.forEach(function (product) {
          if (grid.children.length >= 6) return;
          var variant = matches(product, fields);
          if (!variant) return;
          var item = document.createElement('li');
          var link = document.createElement('a');
          var url = new URL(product.url, window.location.origin);
          url.searchParams.set('variant', variant.id);
          link.href = url.pathname + url.search;
          if (product.image) {
            var image = document.createElement('img');
            image.src = product.image;
            image.alt = '';
            image.width = 360; image.height = 360;
            image.loading = 'lazy';
            link.appendChild(image);
          }
          var title = document.createElement('h3');
          title.textContent = product.title;
          var price = document.createElement('p');
          price.textContent = (variant.title === 'Default Title' ? '' : variant.title + ' · ') + variant.price;
          link.append(title, price); item.appendChild(link); grid.appendChild(item); count++;
        });
        result.hidden = false;
        status.textContent = currencyOK ? (count ? status.dataset.match : status.dataset.empty) : status.dataset.currency;
        var contact = root.querySelector('[data-zk-discovery-contact]');
        var message = 'Assalam o Alaikum! Please help me choose a fragrance. ' + Object.keys(fields).map(function (key) {
          var select = form.elements[key];
          return select.options[select.selectedIndex].text;
        }).join(' · ');
        contact.href = contact.dataset.base + '?text=' + encodeURIComponent(message);
        result.focus();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
